import {
  boolean,
  check,
  nullable,
  number,
  object,
  pipe,
  string,
  type InferOutput
} from 'valibot'

import { VALIDATION_MESSAGES } from '@/constants/common/validation.constants'
import {
  type ToursDetailExEntity,
  type ToursListDetailExEntity
} from '@/libs/api'

/**
 * 運行実績の配送ルートのフォームスキーマ
 */
export const toursRouteFormValueSchema = object({
  /** ReactHookFormで利用する際の判別用ID */
  uniqueId: string(),
  /** 運行実績明細ID */
  id: nullable(number()),
  /** 地点ID */
  siteId: pipe(
    nullable(number()),
    check((siteId) => siteId !== null, VALIDATION_MESSAGES.SELECT_SITE)
  ),
  /** 地点 */
  site: nullable(
    object({
      id: number(),
      name: string(),
      code: string()
    })
  ),
  /** 入日時 */
  entryTime: nullable(string()),
  /** 出日時 */
  exitTime: nullable(string()),
  /** 有効/無効 */
  enable: boolean(),
  /** 修正あり（手動追加）フラグ */
  isAdded: boolean()
})

/**
 * 運行実績の配送ルートのフォーム値
 */
export type ToursRouteFormValue = InferOutput<typeof toursRouteFormValueSchema>

/**
 * 運行実績Entityを行単位のフォーム値に変換する
 */
export const mapToToursRouteFormValue = ({
  id,
  enable,
  site,
  isAdded,
  entryTime,
  exitTime
}: ToursListDetailExEntity | ToursDetailExEntity): ToursRouteFormValue => {
  return {
    uniqueId: String(id),
    id,
    enable,
    siteId: site.id,
    site,
    isAdded,
    entryTime,
    exitTime
  }
}

/**
 * 新規追加時の運行実績の配送ルートのフォーム値を生成
 */
export const createAddedToursRouteFormValue = (): ToursRouteFormValue => ({
  // 追加の場合はprefixをつけた現在時刻（ミリ秒）をユニークIDとして設定
  uniqueId: String(`added_${new Date().getTime()}`),
  id: null,
  enable: true,
  siteId: null,
  site: null,
  isAdded: true,
  entryTime: null,
  exitTime: null
})
